import { useGet } from 'hooks/use-get';
import React, { useContext, useMemo } from 'react';
import { getTreatments } from '../api/get-treatments';

import { useAccountState } from 'contexts/account/account-context';
import { Treatment } from 'views/self-service/features/treatment-catalog/types/treatment.type';

type State = {
  isLoading: boolean;
  treatmentCodes: string[];
  treatments: Treatment[] | undefined;
};

const TreatmentCatalogContext = React.createContext<State | undefined>(undefined);

type TreatmentCatalogProviderProps = {
  children: React.ReactNode;
};

const TreatmentCatalogProvider: React.FC<TreatmentCatalogProviderProps> = ({ children }) => {
  const { account } = useAccountState();

  const { data: treatments, isLoading } = useGet(['getTreatments'], () => getTreatments(String(account.company!.companyId)), {
    enabled: !!account.company!.companyId,
  });

  const treatmentCodes = useMemo(() => treatments?.map((treatment) => treatment.code) ?? [], [treatments]);

  return (
    <TreatmentCatalogContext.Provider value={{ treatmentCodes, treatments, isLoading }}>{children}</TreatmentCatalogContext.Provider>
  );
};

function useTreatmentCatalogState() {
  const context = useContext(TreatmentCatalogContext);
  if (context === undefined) {
    throw new Error('useTreatmentCatalogState must be used within a TreatmentCatalog provider');
  }
  return context;
}

export { TreatmentCatalogProvider, useTreatmentCatalogState };
